import { type ValueOf } from '@shared/types'

export const APIEntity = {
	country: 'countries',
	customer: 'customers',
	engineer: 'engineers',
	materialType: 'materials/types',
	materialShape: 'materials/shapes',
	materialUnits: 'materials/units',
	site: 'sites',
	state: 'states',
	workstation: 'workstations',
	sheets: 'sheets',
	recipes: 'recipes',
	suggestions: 'suggestions',
	jobLateReason: 'job-late-reason',
}
export type APIEntity = ValueOf<typeof APIEntity>

export const APIEntityQuery = {
	ids: 'ids',
	isActive: 'isActive',
	includeInactive: 'includeInactive',
	name: 'name',
	site: 'site',
	operationName: 'operationName',
	shouldGetAll: 'shouldGetAll',
	exclude: 'exclude',
	accessFilter: 'accessFilter',
	page: 'page',
}
export type APIEntityQuery = ValueOf<typeof APIEntityQuery>
